export default __webpack_public_path__ + "static/callout-00ee56992f00560682391136f9b6acef.png";